<template>
  <div class="dndList">
    <div class="left">
      <div class="left-menu" id="dnd_left">
        <div class="tool-icon" :class="currentLeftMenuIndex == index?'tool-icon-active':''" @mouseenter="leftMenuIndexHover = index, currentLeftMenuIndex = index" v-for="(tool,index) in toolBar" :key="index">
          <i class="iconfont" :class="currentLeftMenuIndex == index ? tool.icon_sel : tool.icon"></i>
          <p>{{tool.name}}</p>
        </div>
      </div>
      <div class="left-menu-panel" :style="'top:' + (currentLeftMenuIndex*68 + 1) + 'px'" @mouseleave="leftMenuIndexHover = -1, currentLeftMenuIndex = -1">
        <div class="menu-div">
          <div class="panel-item-menu" :class="[leftMenuPanelIndexHover == index?'panel-item-menu-hover':'',menu.state?menu.state.val:'']" v-for="(menu,index) in comMenu" @click="ClickleftPanelMenu(index,menu)" @mouseleave="leftMenuPanelIndexHover=-1" @mouseenter="leftMenuPanelIndexHover=index" :key="index">
            <span v-if="menu.state" style="position:absolute;display:inline-block;left: 35px;top:-5px;width:50px;padding:1px 8px;z-index:10;color: white;background-color: rgb(234, 169, 40);">{{menu.state.txt}}</span>
            <i class="iconfont" :class="leftMenuPanelIndexHover == index ? menu.icon_sel: menu.icon"></i>
            <span style="margin: 5px 0;">{{menu.name}}</span>
            <span class="line"></span>
          </div>
        </div>
      </div>
    </div>
    <div id="out-view" class="out-view" v-if="outViewShow" @click="outVitrView()">{{ $t('menu.tcxnyw') }}</div>
    <div class="path-btns" v-if="playPathBtn">
      <el-button type="primary" @click="beginRecord">{{ $t('menu.kslz') }}</el-button>
      <el-button type="primary" @click="endRecord">{{ $t('menu.jslz') }}</el-button>
    </div>
    <div class="path-btns2" v-if="pathControl">
      <el-button-group>
        <el-button type="primary" icon="el-icon-video-pause" @click="pausePath">暂停</el-button>
        <el-button type="primary" icon="el-icon-video-play" @click="playPath">继续</el-button>
        <el-button type="primary" icon="el-icon-circle-close" @click="stopPath">停止</el-button>
      </el-button-group>
    </div>
    <div class="alpha" v-if="alphaShow">
      <span class="demonstration">模型透明度</span>
      <el-slider v-model="alpha" :step="0.1" :min="0" :max="1" @change="alphaChange"></el-slider>
      <p>{{alpha * 100}}%</p>
      <div class="quite" @click="alphaShow = false"><i class="iconfont iconicon_special_effects_drop_out"></i></div>
    </div>
    <div class="three-menu" v-if="threeLevelMenu && threeLevelMenu.son && threeLevelMenu.son.length > 0">
      <div class="list" :class="currentEffetIndex === index? 'active': ''" @click="addEffets(menu, index)" v-for="(menu,index) in threeLevelMenu.son" :key="index"><i :class="'iconfont ' + menu.icon"></i>{{menu.name}}</div>
      <div class="quite" @click="closeThreeLevel"><i class="iconfont iconicon_special_effects_drop_out"></i></div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'

export default {
  name: 'draggMenu',  
  data() {
    return {
      dcsFlag: true,
      panelList2: [],
      tableList: [],
      show: true,
      pauseShow: false,
      threeLevelMenu: null,
      threeLevelIndex: -1,
      alpha: 0.4,
      alphaShow: false,
      leftMenuPanelIndexHover: -1,
      leftMenuPanelActiveIndex: -1, //二级菜单激活的index
      leftMenuIndexHover: -1,
      currentLeftMenuIndex: -1, //左边分类激活的index
      toolBar: [],
      toolBarSource: [
        {
          key: 'productMgt',
          label: this.$t('menu.scMGT'),
          code: 1,
          icon: 'iconicon_real_time_data_unsel1',
          icon_sel: 'iconicon_real_time_data_sel',
          name: '生产数据'
        },
        {
          key: 'safetMgt',
          label: this.$t('menu.safeMGT'),
          code: 2,
          icon: 'iconicon_camera_sel',
          icon_sel: 'iconicon_safety_sel',
          name: '监控视频'
        },
        {
          key: 'assetstMgt',
          label: this.$t('menu.zcMGT'),
          code: 3,
          icon: 'iconicon_assets_sel',
          icon_sel: 'iconicon_assets_sel',
          name: '文档管理'
        },
        {
          key: 'toolMgt',
          label:  this.$t('menu.tools'),
          code: 5,
          icon: 'iconicon_toolbox_sel',
          icon_sel: 'iconicon_toolbox_sel',
          name: '工具箱'
        }
      ],
      bottomActiveIndex: null,
      falgs: 'article',
      disabled: false,
      menubtnFlag: 'left',
      leftShow: true,
      viewpointAry: ['front', 'back', 'left', 'right', 'bottom', 'top'],
      list2: [
        {
          id: 1,
          name: this.$t('cctvSys.cctvSys'),
          icon: 'iconicon_camera_unsel',
          icon_sel: 'iconicon_camera_sel',
          url: 'videoMonitor',
          perCode: '4',
          parentCode: 2
        },
        {
          id: 11,
          name: this.$t('virtualTour'),
          icon: 'iconicon_virtual_tour_unsel',
          icon_sel: 'iconicon_virtual_tour_sel',
          url: 'romaing',
          parentCode: 2,
          perCode: '6'
        },
        {
          id: 2,
          name: this.$t('instrData.instrData'),
          icon: 'iconicon_real_time_data_unsel',
          icon_sel: 'iconicon_real_time_data_sel',
          url: 'dataMonitorTable',
          perCode: '2',
          parentCode: 1
        },
        {
          id: 15,
          name: this.$t('pidDraw.pidDraw'),
          icon: 'iconicon_pid_sel',
          icon_sel: 'iconicon_pid_sel',
          url: 'dwglist',
          perCode: '3',
          parentCode: 1
        },
        {
          id: 4,
          name: '工艺流程',
          icon: 'iconicon_technological_unsel',
          icon_sel: 'iconicon_technological_sel',
          url: 'crafts',
          perCode: '5',
          parentCode: 1
        },
        {
          id: 3,
          name: this.$t('docMgt.docMgt'),
          icon: 'iconicon_document_unsel',
          icon_sel: 'iconicon_document_sel',
          url: 'fileManage',
          perCode: '1',
          parentCode: 3
        },
        {
          id: 30,
          name: this.$t('addEff.addEffName'),
          parentCode: 5,
          icon: 'iconicon_special_effects_unsel',
          icon_sel: 'iconicon_special_effects_unsel',
          clickType: 'spe-eff',
          son: [
            {
              id: 1,
              name: this.$t('addEff.addEffRain'),
              icon: 'iconicon_special_effects_rainwater'
            },
            {
              id: 2,
              name: this.$t('addEff.addEffSnow'),
              icon: 'iconicon_special_effects_snowflake'
            },
            {
              id: 3,
              name: this.$t('addEff.addEffSmoke'),
              icon: 'iconicon_special_effects_smoke'
            },
            {
              id: 4,
              name: this.$t('addEff.addEffFire'),
              icon: 'iconicon_special_effects_flame'
            }
          ]
        },
        {
          id: 31,
          name: this.$t('addEff.alpha'),
          parentCode: 5,
          icon: 'iconicon_transparency_unsel',
          icon_sel: 'iconicon_transparency_sel',
          clickType: 'alpha',
        },
      ],
      toggleIndex: null,
      leftMenuStyle: null,
      delBtnStyle: 'height: auto; padding: 1px 0; transition: all .1s;',
      currentIndex: -1,
      perList: [],
      bGravity: false,
      bCollision: false,
      newList2Length: null,
      oldList2Length: null,
      bSkybox: true,
      bBackPic: false,
      tableData: [],
      areaList: [],
      flyArray: [],
      flyStatus: false,
      posList: [],
      safeIndex: 0,
      safeTagList: [],
      safeTagIndex: null,
      addTagList: [],
      safeTypeId: null,
      showSafeArr: [],
      showPartrolList: false,
      perListJson: [],
      tagWidth: 1,
      tagHeight: 1,
      tagDeg: 270,
      tagScale: 0,
      moveX: null,
      moveY: null,
      moveZ: null,
      posY: 0,
      posX: 0,
      posZ: 0,
      setSizeShow: false,
      marker: '',
      markerImg: null,
      tagScale: 1,
      imgHeight: '',
      imgWidth: '',
      outViewShow: false,
      userAccount: '',
      dcsTimer: '',
      dcsData: '',
      currentEffetIndex: null
    }
  },
  computed: {
    playPathBtn() {
      return this.$store.state.playPathBtn
    },
    pathControl() {
      return this.$store.state.pathControl
    },
    comMenu() {
      if (this.currentLeftMenuIndex < 0) return
      let currentCode = this.toolBar[this.currentLeftMenuIndex].code
      let list = []
      // this.findMenu(currentCode, this.list1, list)
      this.findMenu(currentCode, this.list2, list)
      return list
    },
    comModeNameStyle() {
      let style = {}
      if (this.currentIndex == this.list1.length - 1) {
        style['right'] = '0'
      } else {
        style['left'] = this.currentIndex * 51 + 'px'
      }
      return style
    },
    resetView() {
      return this.$store.state.resetview
    }
  },
  created() {
    const _this = this
    // this.getPersonalListFN()
    
    // _this.getUserToolBar()
    this.getPermission()
    if (this.tableList.length === 0) {
      this.getDeviceList()
    }
    // _this.getDcsData()
    let self = this
    document.getElementById('viewer').onclick = function(e) {
      if (!e.target.offsetParent) return
      let parent = e.target.offsetParent.className
      if (
        parent.indexOf('panel-item-menu') >= 0 ||
        parent.indexOf('left-menu') >= 0
      ) {
        // return
      } else {
        self.closeleftPanel()
        self.$bus.$emit('closeSearchPanel', false)
      }
    }
  },
  watch: {    
    pathControl(val) {
      if (val) {
        document.onkeydown = function(e) {
          var key = window.event.keyCode
          if (key == 32) {
            this.dcsFlag = !this.dcsFlag
            if (this.dcsFlag) {
              window.PausePathAnimation()
            } else {
              window.ResumePathAnimation()
            }
          }
        }
        this.showDcs()
        this.setDcsTimer()
      }
    },
    resetView(val) {
      this.outVitrView()
    },
    list2: {
      handler(newV) {
        this.getUserToolBar()
      },
      deep: true
    },
    tagScale(val) {
      let a, b
      if (!this.imgHeight && !this.imgWidth) {
        a = 1
        b = 1
        return
      }
      if (this.imgHeight <= this.imgWidth) {
        a = 1 + val / (this.imgWidth / this.imgHeight)
        b = 1 + val
      } else if (this.imgHeight > this.imgWidth) {
        a = 1 + val
        b = 1 + val / (this.imgHeight / this.imgWidth)
      }
      this.tagHeight = a
      this.tagWidth = b
      this.modifyMarker()
    },
    tagDeg() {
      this.modifyMarker()
    },
    tagHeight() {
      this.modifyMarker()
    },
    tagWidth() {
      this.modifyMarker()
    },
    posX(val) {
      this.moveX = +window.currentPos.split(',')[0] + val
      this.addMarkerPos = [this.moveX, this.moveY, this.moveZ].join(',')
      this.modifyMarker()
    },
    posY(val) {
      this.moveY = +window.currentPos.split(',')[1] + val
      this.addMarkerPos = [this.moveX, this.moveY, this.moveZ].join(',')
      this.modifyMarker()
    },
    posZ(val) {
      this.moveZ = +window.currentPos.split(',')[2] + val
      this.addMarkerPos = [this.moveX, this.moveY, this.moveZ].join(',')
      this.modifyMarker()
    }
  },
  methods: {
    alphaChange(val) {
      window.SetEnvModelAlpha(val)
    },
    getDcsData() {
      ApiService.tables.getPollingTrackRouteLIst({
        mileageID: window.R_config.modelId
      }).then(res => {
        this.dcsData = res.data
      })
    },
    showDcs() {
      this.dcsData.forEach(item => {
        this.dcsList(item)
      })
    },
    dcsList(val) {
      let domstr =  `<div class="dcs-group" id="dcs${val.id}">
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <img src="${require('./../../assets/images/meter_line.png')}" alt="">
                      <div class="group-title">
                        <i></i>
                        <span>${val.bitNumber}${val.deviceName}</span>
                      </div>
                      <div class="group-list">
                      <div class="group-cont">
                        <span>${val.meter}${val.meterName}</span>
                          <p><span id="dcs_${val.id}">${val.locValues}</span>${val.unit}</p>
                      </div>
                    </div>
                  </div>`
      window.AddHtmlMarker(val.location, domstr, 'dcs'+ val.id)
      window.dcsmarker.push('dcs' + window.dcsmarker.length)
      window.dcsArray.push({
        id: `dcs${val.id}`,
        pos: val.location
      })
    },
    setDcsTimer() {
      var dcsTimer = setInterval(n => {
        this.dcsDetail()
      }, 5000)
    },
    dcsDetail() {
      ApiService.tables.getPollingTrackRouteLIst({
        mileageID: window.R_config.modelId
      }).then(res => {
        res.data.map(item => {
          var _obj = document.getElementById('dcs_' + item.id)
          if (_obj) {
            document.getElementById('dcs_' + item.id).innerText = item.locValues
          }
        })
      })
    },
    beginRecord() {
      window.StartRecordPath()
    },
    endRecord() {
      this.$prompt('保存录制', '录制名称', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\s\S]$/,
        inputErrorMessage: '至少一个字符'
      }).then(({ value }) => {
        ApiService.map.addPathData({
          userID: JSON.parse(localStorage.user).userId,
          PathJson: window.StopRecordPath(),
          PathName: value
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            this.$store.commit('showPlayPathBth', false)
          }
        })
      }).catch(() => {
      })
    },
    pausePath() {
      window.PausePathAnimation()
    },
    playPath() {
      window.ResumePathAnimation()
    },
    stopPath() {
      window.StopPathAnimation()
      this.$store.commit('showPathControl', false)
    },
    changeFN(data) {
      // console.log(this.list1, this.list2)
      ApiService.collect.addPersonList({
        userID: JSON.parse(localStorage.user).userId,
        ExtraSettingJson: JSON.stringify({
          bottom: this.list1,
          left: this.list2
        })
      })
    },
    async getPersonalListFN() {
      let result = await ApiService.collect.getPersonList({
        userID: JSON.parse(localStorage.user).userId
      })
      ApiService.user
        .getAuth({
          UserId: JSON.parse(localStorage.user).userId
        })
        .then(res => {
          let a = JSON.parse(res.data[0].PermissionJson)

          let arr = []
          let arr1 = []
          for (let i = 0; i < a.length; i++) {
            arr.push({ perCode: a[i].code })
            arr1.push(a[i].code)
            for (let k = 0; k < a[i].child.length; k++) {
              arr.push({ perCode: a[i].child[k].code })
              arr1.push(a[i].child[k].code)
            }
          }
          this.$store.commit('setPerList', arr1)
          this.perList = arr
          this.perListJson = arr1
          if (res.data[0].UpdateStatus == 0) {
            // 0 权限没有更改
            result.code == 300
              ? (async () => {
                  // 个性化接口是否有数据
                  this.getPermission()
                })()
              : (async () => {
                  //个性化 如果没有数据 用户没有脱拽数据
                  result.data.ExtraSettingJson == ''
                    ? (async () => {
                        this.getPermission()
                      })()
                    : (async () => {
                        var date = JSON.parse(result.data.ExtraSettingJson)
                        this.list1 = date.bottom
                        this.list2 = date.left
                      })()
                })()
          } else {
            // 1 权限更改了
            //设置个性化数据
            // console.log('xxxxxxxxxxxxxxxx',this.list1,this.list2);
            this.getPermission();
            
            ApiService.collect.addPersonList({
              userID: JSON.parse(localStorage.user).userId,
              ExtraSettingJson: JSON.stringify({
                bottom: this.list1,
                left: this.list2
              })
            })

            //更新状态值
            /* ApiService.collect.addUserPrivileges({
              UserId: JSON.parse(localStorage.user).userId,
              updateStatus: '0'
            }) */
          }
        })
      // let a = auth._result.data[0].UpdateStatus;
      // console.log('auth-------------------',auth);
    },
    closeThreeLevel() {
      this.clearEffects()
      this.safeTagList = []
      this.threeLevelMenu = null
      this.threeLevelIndex = -1
      window.ResetAllElement()
      // window.Refresh()
      for (var i = 0; i < this.showSafeArr.length; i++) {
        window.RemoveMarker(this.showSafeArr[i])
      }
      window.delMarkPer = false
    },
    addEffets(menu, index) {
      // console.log(index)
      // console.log(this.currentEffetIndex)
      if (index === this.currentEffetIndex) {
        this.currentEffetIndex = null
        if (index === 0) {
          window.ClearRain()
        } else if (index === 1) {
          window.ClearSnow()
        } else if (index === 2) {
          window.ClearSmoke()
        } else if (index === 3) {
          window.ClearFire()
        }
      } else {
        this.currentEffetIndex = index
        if (index === 0) {
          window.AddRain(window.currentPos)
        } else if (index === 1) {
          window.AddSnow(window.currentPos)
        } else if (index === 2) {
          if (!window.currentPos) {
            this.$message('')
          }
          window.AddSmoke(window.currentPos)
        } else if (index === 3) {
          window.AddFire(window.currentPos)
        }
      }
    },
    getUserToolBar() {
      // let list = []
      // for (let j = 0; j < this.toolBarSource.length; j++) {
      //   let ele = this.toolBarSource[j]
      //   for (let i = 0; i < this.list2.length; i++) {
      //     let e = this.list2[i]
      //     if (e.parentCode == ele.code) {
      //       list.push(ele)
      //       break
      //     }
      //   }
      // }
      // this.toolBar = list
      this.toolBar = this.toolBarSource
    },
    closeleftPanel() {
      this.currentLeftMenuIndex = -1
      this.leftMenuPanelActiveIndex = -1
      this.leftMenuPanelIndexHover = -1
    },
    initDcs() {
      window.dcsmarker = []
      window.dcsArray = []
      clearInterval(this.dcsTimer)
    },
    outVitrView() {
      this.$store.commit('resetView', false)
      clearInterval(this.timer)
      this.initDcs()
      this.hideAllMeters()
      window.SetCameraMode(0)
      SetView(window.R_config.initView)
      this.outViewShow = false
      this.bottomActiveIndex = null
    },
    initModel() {
      clearInterval(this.timer)
      // this.hideAllMeters()
      window.resetView()
      this.outViewShow = false
      this.bottomActiveIndex = null
      this.pauseShow = false
      this.alphaShow = false
      window.clickGlids = null
      window.delMarkPer = false
      this.clearEffects()
      this.initDcs()
    },
    async ClickleftPanelMenu(index, menu) {

      // console.log(index, menu)
      this.initModel()
      if (menu.son) {
        this.closeThreeLevel()
      }
      window.delMarkPer = false
      if (menu.clickType === 'alpha') {
        this.alphaShow = true
      }
      this.threeLevelIndex = null
      if (menu.state && menu.state.val == 'notLine') {
        return
      }
      else if (menu.clickType == 'safeTraining') {
        this.safeIndex = 0
        if (this.perListJson.includes('14-1')) {
          window.delMarkPer = true
        }
        // window.ResetAllElement()
        window.SetCameraMode(2)
      } 
      this.leftMenuPanelActiveIndex = index
      if (menu.son && menu.son.length > 0) {
        // console.log(menu)
        this.threeLevelMenu = menu
      } else {
        this.itemclick(menu.url, index, menu)
      }
      this.closeleftPanel()
    },
    findMenu(code, source, target) {
      source.forEach(ele => {
        if (ele.parentCode == code) {
          target.push(ele)
        }
      })
      this.panelList2 = target
    },
    getPermission() {
      ApiService.user
        .getAuth({
          UserId: JSON.parse(localStorage.user).userId
        })
        .then(res => {
          // debug
          this.getUserToolBar()
          return
          // console.log('res===================', JSON.parse(res.data[0].PermissionJson))
          if (JSON.stringify(res.data) == '{}') {
            this.getUserToolBar()
            return
          }

          const diffarr = [];
          // console.log('this.perList',this.perList);
          if (this.perList.length) {
            let obj = this.perList.reduce((iter, val) => {
              iter[val.perCode] = true
              return iter
            }, {})
            //console.log( Object.entries(obj));
            const diffarr = Object.keys(obj); // 获取所有code
            // console.log('diffarr',diffarr);
            let newList1 = [], newList2 = [];// 一级目录 去除所有的son
            newList1 =  this.list1.filter(item =>diffarr.includes(item.perCode.toString()));
            // console.log('xxx',this.list2,this.list2.length);
            for(var i = 0;i<this.list2.length;i++){
            //  console.log('i',this.list2[i],diffarr.includes(this.list2[i].perCode));
              if(!this.list2[i].perCode){
                newList2.push(this.list2[i])
              }
              if (diffarr.includes(this.list2[i].perCode)) {
                newList2.push(this.list2[i])
              }
            }
            this.list1 = newList1;
            this.list2 = newList2;
            // console.log('this.list2',this.list2);
          }
          this.getUserToolBar()
        })
    },
    async itemclick(val, index, data) {
      this.closeThreeLevel()
      this.clearEffects()
      window.StopViewAnimation()
      this.outViewShow = false
      // window.SetCameraMode(0)
      window.clickGlids = null
      window.delMarkPer = false
      if (!data) {
        //左边菜单点击
        this.bottomActiveIndex = null
      } else {
        if (this.bottomActiveIndex == index) {
          this.bottomActiveIndex = null
          // this.threeLevelMenu = null
          // return
        } else {
          // this.bottomActiveIndex = index
        }
      }
      if (data && data.son && data.son.length > 0) {
        this.threeLevelMenu = data
      }
      if (val === 'manyou') {
        this.flyArray.push(window.GetView())
        // console.log(JSON.stringify(this.flyArray))
      } else if (val === 'patrolRoute') {
        this.$store.commit('showModal', {
          name: 'wayList',
          show: true,
          top: '1rem',
          left: '1rem'
        })
        this.showPartrolList = true
        window.ResetAllElement()
        window.SetCameraMode(2)
        window.SetView(window.R_config.thirdView)
        this.showDcs()
        this.setDcsTimer()
        return
      } else if (!val) {
        return
      }
      // let flag1 = this.$store.state.modals.find(n => {
      //   return n.name === val
      // })
      let obj = {
        name: val,
        show: true,
        top: '40px',
        left: '',
        right: '',
        bottom: ''
      }
      if (val === 'dwglist') {
        obj.left = '70px'
        if (document.getElementById('dataMonitorTable')) {
          obj.left = '392px'
        }
      } else if (val === 'romaing') {
        obj.left = '70px'
      } else if (val === 'dataMonitorTable') {
        obj.left = '70px'
        if (document.getElementById('dwglist')) {
          obj.left = '830px'
        }
      } else if (val === 'videoMonitor') {
        obj.left = '70px'
        if (document.getElementById('dataMonitorTable')) {
          obj.left = '392px'
        }
      } else if (val === 'crafts') {
        // obj.right = '0'
        obj.left = '392px'
      }
      this.$store.commit('showModal', obj)
    },
    dropDownClick(obj) {
      window.StopViewAnimation()
      window.OnClickBlank()
      window.delMarkPer = false
      if (obj.type == 'left') {
        this.threeLevelIndex = obj.val
      }
      if (obj.obj.clickType === 'measure') {
        window.closeMeasure()
        if (obj.val === 4) {
          window.StopMeasure()
          return
        }
        window.StartMeasure(obj.val)
        window.measureType = obj.val
      } else if (obj.obj.clickType === 'mode') {
        if (obj.val === 1 && window.currentPos) {
          window.SetPivot(window.currentPos)
        } else if (obj.val === 3) {
          window.ClipAnimation('z-max', 1.0, 0.0, 15000)
        }
      } else if (obj.obj.clickType === 'SetViewPort') {
        window.SetViewPort(this.viewpointAry[obj.val])
      } else if (obj.obj.clickType === 'showModel') {
        this.$emit('showEQModel', { Group: obj.obj.group, modelname: obj.val })
      } else if (obj.obj.clickType === 'viewType') {
        if (obj.val === 0) {
          window.resetView()
        } else if (obj.val === 1) {
          for (var i = 0; i < window.meterArray.length; i++) {
            window.RemoveMarker(window.meterArray[i])
          }
          window.meterArray = []
          window.ResetAllElement()
          window.SetCameraMode(2)
          window.SetView(window.R_config.thirdView)
          this.showDcs()
          this.setDcsTimer()
        }
      } else if (obj.obj.clickType === 'addtag') {
        if (!window.currentPos) {
          this.$message({
            message: '请选择要添加的位置',
            type: 'warn'
          })
        }
        if (obj.val == 0) {
          if (window.currentPos != '') {
            var myVideo = document.getElementById('video')
            myVideo.play()
            window.AddVideoMarker(
              window.currentPos,
              myVideo,
              16,
              9,
              'marker' + window.markerArray.length
            )
            window.markerArray.push('marker' + window.markerArray.length)
          }
        } else if (obj.val == 1) {
          if (window.currentPos != '') {
            var myVideo = document.getElementById('video2')
            window.AddCameraMarker(
              window.currentPos,
              myVideo,
              16,
              9,
              'marker' + window.markerArray.length
            )
            window.markerArray.push('marker' + window.markerArray.length)
          }
        } else if (obj.val == 2) {
          var htmlStr =
            '<div onclick="onHtmlClick()" style=" color: #000;font-family: sans-serif;padding:5px;border-radius:4px;background: rgba(255, 255, 255, .6);">' +
            '测试Html文本' +
            '<div>'
          window.AddHtmlMarker(
            window.currentPos,
            htmlStr,
            'marker' + window.markerArray.length
          )
          window.markerArray.push('marker' + window.markerArray.length)
        } else if (obj.val == 3) {
          for (var i = 0; i < window.markerArray.length; i++) {
            window.RemoveMarker(window.markerArray[i])
          }
          window.markerArray = []
          for (var i = 0; i < window.dcsmarker.length; i++) {
            window.RemoveMarker(window.dcsmarker[i])
          }
          window.dcsmarker = []
          var myVideo = document.getElementById('video')
          myVideo.pause()
          window.ResetAllElement()
        }
      }
    },
    clearEffects() {
      window.ClearRain()
      window.ClearSnow()
      window.ClearSmoke()
      window.ClearFire()
    },
    menuClick() {
      this.leftShow = !this.leftShow
      this.$store.commit('hideChat', this.leftShow)
      this.leftShow
        ? (this.leftMenuStyle = '')
        : (this.leftMenuStyle = 'left: -12px')
      this.menubtnFlag = this.leftShow ? 'left' : 'right'
    },
    end(ev) {
      if (ev.to.className === 'dragArea11') {
        let id = this.panelList2[ev.oldIndex].id
        let index = this._global.getArrObjItem(this.panelList2, 'id')
        this._global.arrObjRemoveItem(this.list2, 'id', id)
        // this.list2.splice([ev.oldIndex], 1)
        this.currentLeftMenuIndex = -1
        // this.$set(this.list2[ev.oldIndex], 'flag', true)
      }
    },
    handleDel(index, id) {
      if (this.list1.length == 3) {
        return
      }
      const q = this.list2.find((value, index, arr) => {
        return value.id === id
      })
      if (!q) {
        this.list2.push(this.list1[index])
      } else {
        this.$set(q, 'flag', false)
      }
      this.list1.splice(index, 1)
      ApiService.collect
        .addPersonList({
          userID: JSON.parse(localStorage.user).userId,
          ExtraSettingJson: JSON.stringify({
            bottom: this.list1,
            left: this.list2
          })
        })
        .then(res => {
          console.log('删除的', res)
        })
        .catch(err => {
          console.log('err', err)
        })
      this.currentIndex = null
    },
    getDeviceList() {
      ApiService.tree
        .devicelist({
          mileageID: window.R_config.modelId,
          page: 1,
          linit: 50,
          Type: 2
        })
        .then(res => {
          if (res.code == 0) {
            const _this = this
            this.tableData = res.data
            let arr = []
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].glid) {
                arr.push(this.tableData[i].glid)
              }
            }
            this.areaList = Array.from(new Set(arr))
          }
        })
    },
    showMeters() {
      this.areaList.map(item => {
        this.addLabel(item)
      })
    },
    hideAllMeters() {
      window.markerArray.forEach(ele => {
        window.RemoveMarker(ele)
      })
      window.dcsmarker.forEach(ele => {
        window.RemoveMarker(ele)
      })
      this.showSafeArr.forEach(ele => {
        window.RemoveMarker(ele)
      })
      this.showSafeArr = []
      window.markerArray = []
      window.meterArray = []
      window.dcsArray = []
      window.dcsmarker = []

    },
    addLabel(row) {
      // if (row === window.R_config.area3 || row === window.R_config.area4) {
      //   return
      // }
      let dataStr = []
      let areaName = ''
      for (let i = 0; i < this.tableData.length; i++) {
        if (row === this.tableData[i].glid) {
          areaName = this.tableData[i].AreaName
          window.currentElement = this.tableData[i].glidList
          // window.currentPos = this.tableData[i].SpaceJson
          let data = `<div class="group-cont">
                    <span id="qValue_${this.tableData[i].ID}">${
            this.tableData[i].QValue
          }${this.tableData[i].Unit || ''}</span>
                    <p>${this.tableData[i].DeviceName} ${
            this.tableData[i].TagDes
          }</p>
                  </div>`
          dataStr.push(data)
        }
      }
      let htmlStr = `<div class="meter-group" id=${row}>
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <img src="${require('./../../assets/images/meter_line.png')}" alt="">
                      <div class="group-title">
                        <i></i>
                        <span>${this.$t('menu.qy')}</span>
                        <p>${areaName}</p>
                      </div>
                      <div class="group-list">
                      ${dataStr.join('')}
                      </div>
                    </div>`
      window.elementType = 0
      window.AddHtmlMarker(
        window.currentPos,
        htmlStr,
        'marker' + window.meterArray.length
      )
      window.markerArray.push('marker' + window.markerArray.length)
      window.meterArray.push({
        id: row,
        pos: window.currentPos
      })
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.getDeviceList()
        this.showDetail()
      }, 5000)
    },
    showDetail() {
      this.tableData.map(item => {
        var _obj = document.getElementById('qValue_' + item.ID)
        if (_obj) {
          document.getElementById('qValue_' + item.ID).innerText =
            item.QValue + (item.Unit || '')
        }
      })
    },
    safeSel(i, index) {
      if (index === this.safeIndex || i.state) return false
      this.safeIndex = index
      if (i.id === 4) {
        // this.hideAllMeters()
        window.resetView()
      } else if (i.id === 1) {
        window.SetCameraMode(2)
        window.SetView(window.R_config.thirdView)
      }
    },
    handleCommand(val) {
      this.safeTagIndex = null
      this.safeTagList = val.child
      this.safeTypeId = val.id
    },
    modifyMarker() {
      window.ModifyMarker(
        this.marker,
        this.tagWidth,
        this.tagHeight,
        this.tagDeg,
        this.moveX,
        this.moveY,
        this.moveZ
      )
    },
    delTag() {
      window.RemoveMarker(this.marker)
      this.setSizeShow = false
    },
    formatTooltip1(val) {
      return val / 10
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
@import url('../../assets/compcss/draggMenu.css');
.video .card {
  width: 730px !important;
}
.list-complete-item-handle {
  i {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 0.2rem;
  }
}
.dragArea11 .del {
  position: absolute;
  width: 14px;
  height: 14px;
  display: flex;
  top: 3px;
  right: 3px;
  background-color: #666666;
  color: #999999;
  border-radius: 50%;
  font-size: 10px;
  align-items: center;
  justify-content: center;
}
.list-complete-item1 .del:hover {
  background: #e63434;
  color: #999999;
}
.bottom-active {
  background-color: #0078d7;
}
.mode-name {
  color: white;
  position: absolute;
  padding: 3px 8px;
  font-size: 12px;
  top: -22px;
  background-color: #35495d;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.left {
  position: absolute;
  left: 0;
  top: 40px;
  .left-menu-panel {
    position: absolute;
    left: 66px;
    background: #4774A2;
    color: rgba(255, 255, 255, .9);
    font-size: 0.12rem;
    // height: 96px;
    text-align: left;
    z-index: 999999;
    .menu-div {
      display: flex;
      flex-wrap: wrap;
      width: 200px;
    }
    .panel-item-menu-hover {
      color: #fff !important;
      i {
        color: #F3B231;
      }
      .line {
        background: #104F9E !important;
      }
    }
    .panel-item-menu {
      text-align: center;
      height: 64px;
      width: 64px;
      padding: 18px;
      display: inline-flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      transition: all 0.3s;
      position: relative;
      cursor: pointer;
      i {
        font-size: 20px;
      }
      .line {
        height: 2px;
        display: block;
        width: 54px;
        background: transparent;
      }
      &.notLine {
        color: #cccccc;
        &:hover {
          color: #cccccc;
          // background-color: #f5f5f5;
        }
      }
    }
  }
}
.left-menu {
  position: absolute;
  left: 0px;
  display: flex;
  transition: all 0.3s;
  top: 0;
  flex-direction: column;
  width: 64px;
  .tool-icon-active {
    background-color: #F3B231 !important;
    color: white !important;
  }
  .tool-icon {
    width: 100%;
    height: 48px;
    padding: 10px 0;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    background: #4774A2;
    border-bottom: 1px solid rgba(2, 16, 33, 0.15);
    &:hover {
      background-color:  #F3B231;
    }
    i {
      font-size: 20px;
    }
    p {
      font-size: 12px;
    }
  }
}
.left-menu-label {
  position: fixed;
  left: 64px;
  background-color: #0078d7;
  color: white;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding: 0 10px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transition: all 0.3s;
  z-index: 9999;
}
.out-view {
  padding: 10px;
  box-shadow: 0px 0px 4px -2px;
  // border: 1px solid #0078d7;
  border-radius: 4px;
  color: #333;
  background: #f5f5f5;
  position: absolute;
  top: 0.5rem;
  left: 1rem;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: #0078d7;
    color: #fff;
  }
}
.fly-btns {
  position: fixed;
  bottom: 1rem;
  left: 40%;
  .el-button {
    padding: 7px 20px;
  }
}
.path-btns {
  position: fixed;
  bottom: 1rem;
  left: 44%;
  .el-button {
    padding: 7px 20px;
  }
}
.path-btns2 {
  position: fixed;
  bottom: 1rem;
  left: 42%;
  .el-button {
    padding: 7px 20px;
  }
}
.alpha {
  width: 400px;
  height: 40px;
  position: absolute;
  left: 50%; 
  top: 100px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  -webkit-transform: translate(-50%, -50%);
  background: rgba(2, 16, 33, 0.6);
  padding-left: 10px;
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  .quite {
    width: 56px;
    height: 40px;
    border-left: 1px solid rgba(255, 255, 255, .1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .el-slider {
    width: 210px;
  }
}
.three-menu {
  height: 40px;
  position: absolute;
  left: 50%; 
  top: 100px;
  transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
  -webkit-transform: translate(-50%, -50%);
  background: rgba(2, 16, 33, 0.6);
  border-radius: 5px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  .active {
    background: rgba(243, 178, 49, 1);
    color: #fff;
  }
  .list {
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: rgba(255, 255, 255, .65);
    cursor: pointer;
    i {
      margin-right: 10px;
    }
    &:hover {
      background: rgba(243, 178, 49, 1);
      color: #fff;
    }
  }
  .quite {
    width: 56px;
    height: 40px;
    border-left: 1px solid rgba(255, 255, 255, .1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.three-level-menu {
  font-size: 0.14rem;
  position: fixed;
  width: 100vw;
  // height: 20px;
  top: 50px;
  left: 0;
  z-index: -1;
  .safe-menu {
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 4px -2px;
    position: absolute;
    left: 50px;
    border-radius: 4px;
    overflow: hidden;
    span {
      padding: 10px;
      background: #f5f5f5;
      text-align: center;
      display: flex;
      align-items: center;
      color: #ccc;
      cursor: not-allowed;
      i {
        font-style: normal;
        background: #eaa928;
        color: #fff;
        font-size: 12px;
        margin-left: 8px;
        padding: 0 3px;
      }
    }
    .active {
      background: #0078d7;
      color: #fff !important;
    }
  }
  .sel-safe-tag {
    position: absolute;
    right: 150px;
    top: 0;
    // margin: 0 auto;
    // display: inline-flex;
    .el-button {
      padding: 11px;
      font-weight: normal;
    }
    .el-button--primary {
      background-color: #0078d7;
      border-color: transparent;
    }
  }
  .safe-list {
    position: absolute;
    top: 35px;
    right: 50%;
    transform: translate(50%, 50%);
    display: flex;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    div {
      padding: 5px 10px;
      background-color: #383b41;
      color: #d1d2d3;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background-color: #25282d;
        color: #fff;
      }
    }
    .active {
      background-color: #25282d;
      color: #fff;
    }
  }
  .set-size {
    width: 350px;
    // height: 200px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    right: 10%;
    top: 100px;
    position: absolute;
  }
  .three-level-active {
    color: #0078d7 !important;
    background-color: rgb(224, 237, 248) !important;
  }
  .three-level-item {
    display: inline-flex;
    // justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    color: #666666;
    // height: 44px;
    padding: 10px;
    z-index: 1000;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      color: #0078d7;
    }
    // i {
    //   width: 20px;
    //   height: 20px;
    //   font-size: 20px;
    // }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/main/draggMenu.vue